import { createSelectorCreator, defaultMemoize } from 'reselect';
import _ from 'lodash';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, _.isEqual);

const selectSearchPanels = state => state.search.panels;

// eslint-disable-next-line import/prefer-default-export
export const makeSelectSearchPanels = createDeepEqualSelector(selectSearchPanels, panels => panels);
